import { Navigate, useLocation, useParams } from "react-router-dom";
import { useBookingStore } from "../../stores/bookingStore";

/**
 * Keyless `/:identifier/checkout` entry. The canonical route is keyed
 * (`/checkout/:reservationKey`) so a mailed link resolves without session
 * state; this shim keeps the in-app path (and any bookmark) working by
 * redirecting through the stored key, or home when there is no cart.
 *
 * `search` and `state` are carried across: the cart passes `fromBooking`, which
 * is how checkout tells an in-app arrival from a cold link.
 */
export const CheckoutRedirect = () => {
  const { identifier } = useParams<{ identifier: string }>();
  const location = useLocation();
  const storedKey = useBookingStore((s) => s.reservationKey);
  const hasHydrated = useBookingStore((s) => s.hasHydrated);

  // Redirecting before hydration would send a guest with a perfectly good cart
  // to the landing page.
  if (!hasHydrated) return null;

  const target = storedKey
    ? `/${identifier}/checkout/${storedKey}${location.search}`
    : `/${identifier}${location.search}`;

  return <Navigate to={target} replace state={location.state} />;
};

export default CheckoutRedirect;
